export const normalizeSubscribeStatus = (status) => {
    if (status === true) {
        return true;
    }
    if (status === false) {
        return false;
    }
    return null;
};

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export const subscribeStatusMapFromIds = (subscribeIds = []) => (
    subscribeIds.reduce((statusById, subscribeId) => {
        if (subscribeId) {
            statusById[subscribeId] = true;
        }
        return statusById;
    }, {})
);

export const normalizeSubscribeStatusById = (subscribeStatusById, fallbackSubscribeIds = []) => {
    if (!subscribeStatusById || typeof subscribeStatusById !== 'object' || Array.isArray(subscribeStatusById)) {
        return subscribeStatusMapFromIds(fallbackSubscribeIds);
    }

    return Object.entries(subscribeStatusById).reduce((statusById, [subscribeId, subscribeStatus]) => {
        const normalizedStatus = normalizeSubscribeStatus(subscribeStatus);
        if (normalizedStatus !== null) {
            statusById[subscribeId] = normalizedStatus;
        }
        return statusById;
    }, {});
};

export const subscribeIdsFromStatusById = (subscribeStatusById = {}) => (
    Object.entries(subscribeStatusById)
        .filter(([, subscribeStatus]) => subscribeStatus === true)
        .map(([subscribeId]) => subscribeId)
);

export const applySubscribeStatus = (subscribeStatusById = {}, subscribeId, subscribeStatus) => {
    const nextSubscribeStatusById = { ...subscribeStatusById };
    const normalizedStatus = normalizeSubscribeStatus(subscribeStatus);

    if (!subscribeId) {
        return nextSubscribeStatusById;
    }

    if (normalizedStatus === null) {
        delete nextSubscribeStatusById[subscribeId];
    } else {
        nextSubscribeStatusById[subscribeId] = normalizedStatus;
    }

    return nextSubscribeStatusById;
};

export const applySubscribeStatusEntries = (subscribeStatusById = {}, subscribeStatuses = []) => (
    subscribeStatuses.reduce((nextSubscribeStatusById, subscribeStatusEntry) => (
        applySubscribeStatus(
            nextSubscribeStatusById,
            subscribeStatusEntry.subscribeId,
            subscribeStatusEntry.subscribeStatus,
        )
    ), subscribeStatusById)
);

export const getSubscribeStatus = (subscribeStatusById = {}, subscribeIds = [], subscribeId) => {
    if (subscribeStatusById && hasOwn(subscribeStatusById, subscribeId)) {
        return normalizeSubscribeStatus(subscribeStatusById[subscribeId]);
    }
    return subscribeIds?.includes(subscribeId) ? true : null;
};
